module.exports = __webpack_public_path__ + "img/9788980406340.2079296c.jpg";